import { inject } from '@angular/core';
import type { CanActivateFn, RedirectFunction } from '@angular/router';
import { Router } from '@angular/router';
import { PartnerStudioResource } from '../features/partner/domain/infrastructure/partner-cabinet.resource';

export const partnerCabinetGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const studios = inject(PartnerStudioResource);

  return (await studios.myStudio()) ? true : router.createUrlTree(['/projects']);
};

/**
 * The designer belongs to the photographer's lane. A partner studio only LOOKS at its packs — it uploads
 * the files and prices them in its own cabinet, so a hand-typed editor URL goes back to that cabinet.
 */
export const notPartnerGuard: CanActivateFn = async () => {
  const router = inject(Router);
  const studios = inject(PartnerStudioResource);

  return (await studios.myStudio()) ? router.createUrlTree(['/partner/templates']) : true;
};

/**
 * The cabinet's landing fork. A `canMatch` guard cannot carry it: `expandSegmentAgainstRouteUsingRedirect`
 * matches a `redirectTo` route without running its guards, so a guarded redirect would fire for everyone.
 */
export const partnerRootRedirect: RedirectFunction = async () =>
  (await inject(PartnerStudioResource).myStudio()) ? 'partner' : 'projects';
